function Card(props) {
    return (
        <div className="flex flex-col items-center justify-top gap-4 p-8 bg-white w-80 lg:h-[500px] rounded-lg">
            {props.children}
        </div>
    )
}

export default Card